const DOCUMENT = 'SPECIFIC_AGREEMWNTS_';

const actions = {
  ADD_RULE: DOCUMENT + 'ADD_RULE',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CREATE: DOCUMENT + 'CREATE',
  EDIT: DOCUMENT + 'EDIT',
  LOAD_COMPANY_PRICING_AGREEMENTS_DATA_SUCCESS: DOCUMENT + 'LOAD_COMPANY_PRICING_AGREEMENTS_DATA_SUCCESS',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  SAVE_RULES: DOCUMENT + 'SAVE_RULES',
  TOUCH: DOCUMENT + 'TOUCH',

  addRule: data => ({ type: actions.ADD_RULE, payload: data }),
  changeProperty: data => ({ type: actions.CHANGE_PROPERTY, payload: data }),
  clearStore: () => ({ type: actions.CLEAR_STORE }),
  create: data => ({ type: actions.CREATE, payload: data }),
  edit: data => ({ type: actions.EDIT, payload: data }),
  loadFormDataSuccess: data => ({ type: actions.LOAD_FORM_DATA_SUCCESS, payload: data }),
  loadRequest: data => ({ type: actions.LOAD_REQUEST, payload: data }),
  loadSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),
  saveRules: data => ({ type: actions.SAVE_RULES, payload: data }),
  touch: data => ({ type: actions.TOUCH, payload: data }),
  loadCompanyPricingAgreementsDataSuccess: data => ({
    type: actions.LOAD_COMPANY_PRICING_AGREEMENTS_DATA_SUCCESS,
    payload: data,
  }),
};

export default actions;
